#import "./contact-context-fragment.graphql"

fragment AccountContext on Account {
    id
    name
    description
    createdTime
    industry {
        id
        name
    }
    primaryContact {
        ...ContactContext
    }
    owner {
        id
        name
    }
    emailAddresses {
        primary {
            name
        }
    }
    phones {
        primary {
            name
            value {
                numberFormatted
            }
        }
    }
    postalAddresses {
        primary {
            name
            value {
                address_1
                city
                state
                postalCode
                country
            }
        }
    }
    createdTime
}
